<template>
  <el-dialog title="Importar Planilha Faturamento" center :close-on-click-modal="false" :visible.sync="dialog">
    <el-form :model="ruleForm" label-position="top">
      <el-row :gutter="5">
        <el-col :span="12">
          <el-form-item label="Periodo">
            <MonthList ref="month" v-model="ruleForm.month" :quantity="12" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :span="24">
          <el-upload class="avatar-uploader" drag ref="upload" action="/api/invoice.excel/upload" :limit="1"
            :show-file-list="true" :auto-upload="false" :multiple="false" :on-change="changeFile">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Arraste aqui ou <em>clique para upload</em>
            </div>
            <div class="el-upload__tip" slot="tip">csv files</div>
          </el-upload>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialog = false">Cancelar</el-button>
      <el-button type="primary" @click="upload()">Importar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { InvoiceExcelService } from "@/services/customers/invoice.excel.services";
import MonthList from "./MonthList.vue";

export default {
  name: "InvoiceExcelImport",
  data() {
    return {
      ruleForm: {
        month: '',
      },
      dialog: false,
    };
  },
  mounted() {
  },
  methods: {
    open() {
      const vm = this;
      vm.dialog = true;
    },
    changeFile(file) {
      var vm = this;
      vm.file = file;
    },
    upload() {
      const vm = this;
      if (!vm.file) {
        return vm.$message({
          type: "error",
          message: "Você deve selecionar um arquivo para realizar o upload",
        });
      }
      const loading = vm.$loading(vm.$options.loading);
      InvoiceExcelService.upload(vm.$refs.month.get(), vm.file)
        .then((response) => {
          vm.$emit("uploaded", response);
          vm.dialog = false;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  components: { MonthList }
};
</script>
<style scoped>
.el-upload--text {
  width: 100%;
}

.el-upload--text {
  width: 100%;
}
</style>